export default __webpack_public_path__ + "static/Discovery-and-Visibility-11a38dfc0d470e2a263ca5bbb7e9fb75.pdf";